/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { createSlice } from '@reduxjs/toolkit'
import { RootState } from './store';

// Define a type for the slice state

export enum UserType {
  USER = 'user', ADMIN = "Admin", SUPER_ADMIN = "SuperAdmin"
}

export interface User {
  email: string
  family_name: string
  given_name: string
  name: string
  sub: string
  subname: string
  userType: UserType
}

interface LogginState {
  isLoggedIn: boolean,
  loginRequested:boolean,
  AppAuthHelper:any,
  appMaintenance:boolean,
  maintenanceMessage:string,
  user?:User
}

// Define the initial state using that type
const initialState: LogginState = {
  isLoggedIn: false,
  loginRequested:false,
  AppAuthHelper:undefined,
  appMaintenance:false,
  maintenanceMessage:"",
}

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    toggleLogin: (state,action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.isLoggedIn =action.payload;
      if(action.payload ===true){
       // window.location.href ='dashboard'
      }else{
        //window.location.href ='login'
      }
    },
    setMaintenanceMessage:(state,action)=>{
      state.maintenanceMessage = action.payload
    },
    setMaintenanceEnabled:(state,action)=>{
      state.appMaintenance = action.payload
    },
    setLoginRequested:(state,action)=>{
      state.loginRequested = action.payload
    },
    setUser:(state,action)=>{
      state.user = action.payload
    },
    setAppAuthHelper:(state,action)=>{
      state.AppAuthHelper=action.payload
    }
  },
})

// Action creators are generated for each case reducer function
export const { toggleLogin,setUser,setLoginRequested,setAppAuthHelper,setMaintenanceEnabled,setMaintenanceMessage } = loginSlice.actions;
export const isLoggedInSelector = (state: RootState) => state.login;

export default loginSlice.reducer;